// extracted by css-extract-rspack-plugin
export default {"ModalHeader":"FilterModal-module__ModalHeader___puOVY","ModalBody":"FilterModal-module__ModalBody___JLrOD","ModalFooter":"FilterModal-module__ModalFooter___CGYv3"};